import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Button from '../../components/UI/Button/Button';
import Input from '../../components/UI/Input/Input';
import classes from './Login.module.css';
import * as actions from '../../store/actions/index';
import Spinner from '../../components/UI/Spinner/Spinner'
import { Button } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha";
import * as extensionsReq from "../../axios/requests/extensionsReq"
import * as loginReq from '../../axios/requests/loginReq'
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import i18next from "i18next";


const reCaptchaSitekey = "6LeBK5AcAAAAAGb0sZHvmSBlWRkXzPL4K2TsoY1N"
class Login extends Component {
    state = {
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: this.props.t('Email')
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: this.props.t('Password')
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 8
                },
                valid: false,
                touched: false
            },

        },
        extensions: undefined,
        selectedDevice: undefined,
        token: undefined,
        errorMsg: undefined,
        ReCaptchaValue: '',
        isAgreementTouched: false,
        isPrivacyPolicyAccepted: false,
        allowToLoginApp: false,
        isTermOfUseAccepted: false,
        loginPage: 'Login',//[Login,Device,Agreement]
        selectedLangCode: 'he'//[he,en]
    };

    componentDidMount() {
        const savedLanguage = localStorage.getItem('app-language');
        if (savedLanguage) {
            // this.setState({ selectedLangCode: savedLanguage });
            this.onSelectNewLangHandler(savedLanguage)
        }
        else {
            this.onSelectNewLangHandler(i18next.language)
            // this.setState({ selectedLangCode: i18next.language })
        }
    }
    handleOnCaptchaVerify = (token) => {
        this.setState({ isCaptchaOk: true })
    }

    inputChangedHandler = (event, controlName) => {
        const updateControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity(event.target.value, this.state.controls[controlName].validation),
                touched: true
            }

        };
        this.setState({ controls: updateControls });
    }

    checkValidity = (value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid
        }

        if (rules.isEmail) {
            const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            isValid = pattern.test(value) && isValid
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid
        }

        return isValid;
    }

    agreementNextBtnClickHandler = async (ReCaptchaValue) => {
        try {
            if (this.state.isTermOfUseAccepted && this.state.isPrivacyPolicyAccepted) {
                await loginReq.agreementAcception(this.state.controls.email.value, this.state.controls.password.value, this.state.isTermOfUseAccepted, this.state.isPrivacyPolicyAccepted)//.loginReq
                const user = await loginReq.loginReq(this.state.controls.email.value, this.state.controls.password.value, ReCaptchaValue)

                // if (!user?.token) {
                //     return this.setState({ errorMsg: user })
                // }
                this.fetchDevices(user)
            }
            else {
                this.setState({ errorMsg: this.props.t('To enter the system, you must confirm the terms of use and the privacy policy') })
            }
        } catch (e) {
            this.setState({ errorMsg: this.props.t(e.message || e) })
        }
    }

    loginHandler = async (event) => {//todo
        try {
            event.preventDefault(); //To not load the page again
            // if ((this.state.ReCaptchaValue && this.state.ReCaptchaValue !== '') || (process.env.NODE_ENV === "development")) {//todo || true
            if (this.state.loginPage === 'Agreement') {
                this.agreementNextBtnClickHandler(this.state.ReCaptchaValue)
            }
            else if (this.state.loginPage === 'Login') {
                this.onNextToSelectDeviceClicked(this.state.ReCaptchaValue)
            }
            else {
                if (this.state.selectedDevice) {
                    if (this.state.selectedDevice !== 'Empty') {
                        const foundSelectedDevice = this.state.extensions.find(extension => extension.device === this.state.selectedDevice.device)
                        if (!foundSelectedDevice) return this.setState({ errorMsg: 'device not found.' })//alert('device not found.')
                        if (foundSelectedDevice.onlineAgent) return this.setState({ errorMsg: 'Agent ' + foundSelectedDevice.onlineAgent + ' is logged in.' })//alert('Agent ' + foundSelectedDevice.onlineAgent + ' is logged in.')
                    }
                    await extensionsReq.setOnlineAgent(this.state.selectedDevice !== 'Empty' ? this.state.selectedDevice.device : this.state.selectedDevice, this.state.token)

                    this.props.onLogin(this.state.controls.email.value, this.state.controls.password.value, true, this.state.ReCaptchaValue)
                }
                else {
                    // alert('Please select extension.')
                    this.setState({ errorMsg: 'Please select extension.' })
                }
            }
            // }
        } catch (e) {
            const agentName = e.response?.data?.match(/Agent (\w+) online/)[1];
            this.setState({ errorMsg: this.props.t('Please check if someone already login to the extension', { agent: agentName }) });
        }

    }

    async fetchDevices(user) {
        const token = user.token
        let extensions = await extensionsReq.getExtensions(token)
        const ext = extensions.find(extItem => extItem.device === user.user.device)
        let lastSelectedDevice = ext
        this.props.fetchCompanyExtsSuccess(extensions)
        if (!lastSelectedDevice) lastSelectedDevice = 'Empty'
        this.setState({ extensions: extensions, selectedDevice: lastSelectedDevice, token: token, errorMsg: undefined, loginPage: 'Device', allowToLoginApp: true })
    }
    //todo
    onNextToSelectDeviceClicked = async (ReCaptchaValue) => {
        try {
            const user = await loginReq.loginReq(this.state.controls.email.value, this.state.controls.password.value, ReCaptchaValue)
            const { isPrivacyPolicyAccepted, isTermOfUseAccepted } = user?.user || {}
            this.setState({ isPrivacyPolicyAccepted, isTermOfUseAccepted })//isAgreementTouched: true,
            // if (!user?.token) {
            //     this.setState({ errorMsg: user })
            // }
            if (!(isPrivacyPolicyAccepted && isTermOfUseAccepted)) {
                this.setState({ isAgreementTouched: true, loginPage: 'Agreement' })
            }
            else {
                this.fetchDevices(user)
            }
        } catch (e) {
            this.setState({ errorMsg: this.props.t(e.message || e) })
        }
    }

    HandleOnSelectDevice = (device) => {
        this.setState({ selectedDevice: device })//.device
    }

    // signUpHandler = (event) => {
    //     event.preventDefault(); //To not load the page again
    //     let isSignup = true;
    //     if ((this.state.ReCaptchaValue && this.state.ReCaptchaValue !== '') || (process.env.NODE_ENV === "development")) {
    //         this.props.onLogin(this.state.controls.email.value, this.state.controls.password.value, isSignup)
    //     }
    // }
    onChangeReCaptcha = (value) => {
        // console.log("Captcha value:", value);
        this.setState({ ReCaptchaValue: value })
    }

    handleCheckBoxChange = (checkboxName) => {
        switch (checkboxName) {
            case 'terms':
                this.setState({ isTermOfUseAccepted: !this.state.isTermOfUseAccepted })
                break;
            case 'privacy-policy':
                this.setState({ isPrivacyPolicyAccepted: !this.state.isPrivacyPolicyAccepted })
                break;
        }
    }

    onSelectNewLangHandler(langCode) {
        this.setState({ selectedLangCode: langCode })
        i18next.changeLanguage(langCode); // Dynamically change language
        localStorage.setItem('app-language', langCode);
        // if (langCode === 'en') {
        //     document.documentElement.setAttribute('dir', 'rtl');
        // }
        // else{
        //     document.documentElement.setAttribute('dir', 'ltr');
        // }

    }

    render() {
        const { t } = this.props
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(formElement => (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={(event) => this.inputChangedHandler(event, formElement.id)} />
        ));

        if (this.props.loading && !this.props.isBtnLogginTouched) {
            form = <Spinner />
        }
        let errorMsg = null;
        if (this.state.errorMsg) {
            errorMsg = (
                <p className={classes['error-log']}>{this.state.errorMsg}</p>
            );
        }
        // else if (this.props.error) {
        //     errorMsg = this.props.error.message ? this.props.error.message : this.props.error
        //     // errorMsg = (
        //     //     <p>{this.props.error.message}</p>
        //     // );
        // }

        //todo lang this.props.t('')
        let loginSection = (
            <div className='row'>
                <div className='col-12'>
                    <div className={classes['lang-dropdown-container']}>
                        <Dropdown drop='down' className={classes['lang-dropdown']}>
                            <Dropdown.Toggle variant="secondary" className={classes['lang-dropdown-btn']}>
                                <p className={classes['lang-dropdown-btn-p']}>
                                    <span>{this.props.t(this.state.selectedLangCode)}</span>
                                    <i class="fa-solid fa-globe" />
                                </p>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={`${classes['lang-dropdown-menu']}`}>
                                <Dropdown.Item onClick={() => this.onSelectNewLangHandler('he')} className={classes['lang-dropdown-menu-item']} >
                                    <p className={classes['lang-dropdown-menu-p']}>
                                        {this.state.selectedLangCode === 'he' && <i class="fa-solid fa-circle" />}
                                        {this.state.selectedLangCode !== 'he' && <i class="fa-regular fa-circle" />}
                                        <span>{this.props.t('he')}</span>
                                    </p>
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => this.onSelectNewLangHandler('en')} className={classes['lang-dropdown-menu-item']}>
                                    <p className={classes['lang-dropdown-menu-p']}>
                                        {this.state.selectedLangCode === 'en' && <i class="fa-solid fa-circle" />}
                                        {this.state.selectedLangCode !== 'en' && <i class="fa-regular fa-circle" />}
                                        <span>{this.props.t('en')}</span>
                                    </p>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    {form}
                    <div className={classes.reCaptchaDiv}>
                        <ReCAPTCHA
                            sitekey={reCaptchaSitekey}
                            onChange={this.onChangeReCaptcha}
                        />
                    </div>
                </div>
            </div>
        )
        let nextBtn = this.props.t('Login')
        let extensionsElements = undefined
        if (this.state.extensions) {
            extensionsElements = this.state.extensions.map(extension => {
                let dropDownItemName = `${extension.device} (${extension.shortNum})`
                if (!!extension.onlineAgent) {
                    dropDownItemName = <div><span className={classes.alreadyLoggedAgent}>({this.props.t('Connected')}) </span> <span>{dropDownItemName}</span></div>
                }
                return <Dropdown.Item key={extension._id} disabled={!!extension.onlineAgent} className={classes.selectExtDropItem} onClick={() => this.HandleOnSelectDevice(extension)}>{dropDownItemName}</Dropdown.Item>
            })
            const noExt = <Dropdown.Item key={0} className={classes.selectExtDropItem} onClick={() => this.HandleOnSelectDevice('Empty')}>{this.props.t('Without Extension')}</Dropdown.Item>
            extensionsElements = [noExt, ...extensionsElements]
            nextBtn = this.props.t('Next')
        }
        let selectDeviceSection = (
            <div className='row'>
                <div className='col-12'>
                    <div className={classes.selectDeviceSection}>
                        <Dropdown drop='left' className={classes.selectDeviceDropDownBtnDiv}>
                            <Dropdown.Toggle variant="secondary" className={classes.selectDeviceDropDownBtn}>
                                {this.state.selectedDevice?.device && this.state.selectedDevice !== 'Empty' ? `${this.state.selectedDevice?.device} (${this.state.selectedDevice.shortNum})` : this.props.t('No extension')}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={`${classes['select-device-dropdown-menu']}`}>
                                {extensionsElements}
                            </Dropdown.Menu>
                        </Dropdown>
                        <span className={classes.selectDeviceTitle}>:{this.props.t('Extension')}</span>
                    </div>
                </div>
            </div>
        )
        // this.props.t('Email')
        const acceptAgreementSection =
            <article className={classes['agreementSection']}>
                <header>
                    <h1 className={classes['agreement-title']}>{t('Please read Effective app agreement')}</h1>
                    <p className={classes['agreement-description']}>{t('To use the application, you must agree to the terms of use and confirm reading the privacy policy')}</p>
                </header>
                <section>
                    <div className={classes['agreement-item']}>
                        <input
                            className={classes['checkbox']}
                            type="checkbox"
                            checked={this.state.isTermOfUseAccepted}
                            onChange={() => this.handleCheckBoxChange('terms')}
                        />
                        <p className={classes["description"]}>{t('I have read and agree to the')}
                            <span>
                                <a target="_blank" href='https://www.itcweb.us/user-policy/'>
                                    {t('Terms of use')}
                                </a>
                            </span>
                        </p>
                    </div>
                    <div className={classes['agreement-item']}>
                        <input
                            className={classes['checkbox']}
                            type="checkbox"
                            checked={this.state.isPrivacyPolicyAccepted}
                            onChange={() => this.handleCheckBoxChange('privacy-policy')}
                        />
                        <p className={classes["description"]}>{t('I have read and agree to the')}
                            <span>
                                <a target="_blank" href='https://www.itcweb.us/privacy-policy/'>
                                    {t('privacy policy')}
                                </a>
                            </span>
                        </p>
                    </div>
                </section>
            </article>

        let visibleForm = undefined

        if (this.state.isAgreementTouched && (!(this.state.isPrivacyPolicyAccepted && this.state.isTermOfUseAccepted) || !this.state.allowToLoginApp)) {
            visibleForm = acceptAgreementSection
            nextBtn = this.props.t('Next')
        }
        else if (!this.state.extensions) visibleForm = loginSection
        else if (this.state.extensions && this.state.isPrivacyPolicyAccepted && this.state.isTermOfUseAccepted) visibleForm = selectDeviceSection


        return (
            <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-4'>
                    <div className={classes.Login}>
                        {errorMsg}
                        <form onSubmit={this.loginHandler}>
                            {visibleForm}
                            <div className={'row ' + classes.addMargeTop}>
                                {/* <div className='col-2'></div> */}

                                <div className='col-12'>
                                    <Button variant="success" size="lg" type="submit" className={classes.loginButton} >{nextBtn}</Button>
                                    {/* <Button variant="secondary" size="lg" onClick={this.signUpHandler} disabled={true} className={classes.loginButton}>SignUp</Button> */}
                                </div>
                                {/* <div className='col-4'>
                                

                                </div> */}

                                {/* <div className='col-2 '> */}

                                {/* </div> */}
                            </div>

                        </form>
                    </div>
                </div>
                <div className='col-md-4'></div>
            </div>
        );
    };
}
const mapStateToProps = state => {
    return {
        loading: state.login.loading,
        error: state.login.error,
        isBtnLogginTouched: state.login.isBtnLogginTouched
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onLogin: (email, password, isBtnLogginTouched, ReCaptchaValue) => dispatch(actions.login(email, password, isBtnLogginTouched, ReCaptchaValue)),
        fetchCompanyExtsSuccess: (companyExts) => dispatch(actions.fetchCompanyExtsSuccess(companyExts))
    };
};
export default withTranslation('common')(connect(mapStateToProps, mapDispatchToProps)(Login));